import {
  SERVICE_WORKER_GENERAL_SETTINGS as SERVICE_WORKER_SERVICE_WORKER_GENERAL_SETTINGS
} from '../../../../ServiceWorker/src/constants/service-worker.constants';

export { SERVICE_WORKER_SERVICE_WORKER_GENERAL_SETTINGS as SERVICE_WORKER_GENERAL_SETTINGS };
